/* b2goshop · comportamiento del tema v7 */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = function (pesos) { return '$' + String(Math.round(pesos)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var DATA = { caps: [] };
  try { DATA = JSON.parse(($('#b2-data') || {}).textContent || '{}'); if (!DATA.caps) DATA.caps = []; } catch (e) {}

  var byId = {};
  DATA.caps.forEach(function (c) { (c.prods || []).forEach(function (p) { if (!byId[p.id]) byId[p.id] = { p: p, caps: [] }; byId[p.id].caps.push(c); }); });

  /* ---------- Revelado ---------- */
  function reveal() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (ens) {
      ens.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    $$('[data-reveal]').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('b2-rv'); io.observe(el);
    });
  }

  /* ---------- Galería ---------- */
  function gallery() {
    var g = $('[data-gal]'); if (!g) return;
    var track = $('[data-gal-track]', g), slides = $$('[data-gal-slide]', g), dots = $$('[data-gal-dot]', g);
    var thumbs = $$('[data-gal-thumb]'), count = $('[data-gal-count]', g), cur = -1;
    function set(i) {
      if (i === cur) return; cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    track.addEventListener('scroll', function () { set(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, { passive: true });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); set(k); });
    });
    set(0);
  }

  /* ---------- Visor ---------- */
  var lb = null, lbLast = null;
  function openLb(src, alt) {
    lb = lb || $('#b2-lb'); if (!lb || !src) return;
    lbLast = document.activeElement;
    var img = $('img', lb); img.src = src; img.alt = alt || '';
    lb.hidden = false; document.body.classList.add('b2-lock');
    var x = $('.b2-lb__x', lb); if (x) x.focus();
  }
  function closeLb() {
    if (!lb || lb.hidden) return;
    lb.hidden = true; document.body.classList.remove('b2-lock');
    if (lbLast && lbLast.focus) lbLast.focus();
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom]');
    if (z) { e.preventDefault(); openLb(z.getAttribute('data-zoom'), z.getAttribute('data-alt')); return; }
    if (lb && !lb.hidden && e.target.closest('#b2-lb')) closeLb();
  });

  /* ---------- Carrito (API AJAX de Shopify) ---------- */
  var cart = { items: [], item_count: 0, total_price: 0 };
  function api(path, body) {
    var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return fetch(ROOT + path, opt).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || 'No se pudo actualizar el pedido.'); throw err; }
        return j;
      });
    });
  }
  function load() { return api('cart.js').then(function (c) { cart = c; paint(); return c; }); }
  /* pids: id del producto, o lista "principal,oferta2,oferta3" separada por comas.
     Al elegir una oferta se quita del pedido cualquier otra oferta del mismo grupo. */
  function addVariant(vid, pids) {
    vid = Number(vid);
    var grp = String(pids || '').split(',').map(Number).filter(Boolean);
    return api('cart.js').then(function (c) {
      var updates = {}, has = false, need = true;
      c.items.forEach(function (it) {
        if (grp.indexOf(it.product_id) > -1 && it.variant_id !== vid) { updates[it.key] = 0; has = true; }
        if (it.variant_id === vid) need = false;
      });
      var p = has ? api('cart/update.js', { updates: updates }) : Promise.resolve();
      return p.then(function () { return need ? api('cart/add.js', { items: [{ id: vid, quantity: 1 }] }) : null; });
    }).then(load);
  }
  function removeKey(key) { return api('cart/change.js', { id: key, quantity: 0 }).then(function (c) { cart = c; paint(); }); }

  /* ---------- Panel "Tu pedido" ---------- */
  var dr = null, drLast = null;
  function openDr() {
    dr = dr || $('#b2-pedido'); if (!dr) return;
    drLast = document.activeElement;
    dr.hidden = false; document.body.classList.add('b2-lock'); bar(false);
    var x = $('.b2-x', dr); if (x) x.focus();
  }
  function closeDr() {
    if (!dr || dr.hidden) return;
    dr.hidden = true; document.body.classList.remove('b2-lock'); barCheck();
    if (drLast && drLast.focus) drLast.focus();
  }
  function unitsOf(title) { var m = /^(\d+)/.exec(String(title || '')); return m ? Math.max(1, parseInt(m[1], 10)) : 1; }
  function paint() {
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.variant_id] = true; inCart['p' + it.product_id] = true; });
    $$('[data-add-comp]').forEach(function (b) {
      var on = !!inCart[b.getAttribute('data-vid')];
      b.classList.toggle('is-in', on);
      b.textContent = on ? 'En tu pedido' : 'Agregar a mi pedido';
    });
    $$('[data-open-pedido]').forEach(function (b) {
      b.hidden = !cart.item_count;
      var n = $('[data-cart-count]', b); if (n) n.textContent = cart.item_count;
    });
    var box = $('#b2-pedido'); if (!box) return;
    var list = $('[data-items]', box), tot = $('[data-total]', box), sugW = $('[data-sugs]', box), go = $('[data-go]', box), empty = $('[data-empty]', box);
    var items = cart.items || [];
    empty.hidden = items.length > 0; go.hidden = items.length === 0; $('[data-list]', box).hidden = items.length === 0;
    list.innerHTML = items.map(function (it) {
      var info = byId[it.product_id] ? byId[it.product_id].p : null;
      var pesos = it.final_line_price / 100, detail;
      if (info && !info.comp) {
        /* info.u: cantidad de la oferta (1, 2, 3) cuando el producto usa ofertas separadas */
        var n = info.u || unitsOf(it.variant_title);
        var lab = info.u ? (n === 1 ? '1 ' + (info.us || 'unidad') : n + ' ' + (info.un || 'unidades')) : (it.variant_title || '');
        detail = esc(lab) + ' · ' + fmt(pesos / n) + ' cada ' + esc(info.us || 'unidad');
      } else { detail = it.quantity > 1 ? it.quantity + ' unidades' : '1 unidad'; }
      return '<div class="b2-item"><div class="b2-item__txt"><span class="b2-item__n">' + esc(info ? info.t : it.product_title) + '</span><span class="b2-item__d">' + detail + '</span>' +
        (items.length > 1 ? '<button type="button" class="b2-item__rm" data-rm="' + esc(it.key) + '">Quitar</button>' : '') +
        '</div><span class="b2-item__p">' + fmt(pesos) + '</span></div>';
    }).join('');
    tot.textContent = fmt((cart.total_price || 0) / 100);
    /* Sugerencias: complementarios del capítulo de lo que ya está en el pedido */
    var base = items.filter(function (it) { return byId[it.product_id] && !byId[it.product_id].p.comp; });
    var src = base.length ? base : items, caps = [], seen = {};
    src.forEach(function (it) { (byId[it.product_id] ? byId[it.product_id].caps : []).forEach(function (c) { if (!seen[c.h]) { seen[c.h] = 1; caps.push(c); } }); });
    var sugs = [];
    caps.forEach(function (c) { (c.prods || []).forEach(function (p) { if (sugs.length < 2 && p.comp && p.avail && !inCart['p' + p.id]) sugs.push(p); }); });
    sugW.hidden = sugs.length === 0;
    $('[data-sug-list]', sugW).innerHTML = sugs.map(function (p) {
      return '<div class="b2-sug"><div><span class="b2-sug__n">' + esc(p.t) + '</span><span class="b2-sug__p">' + fmt(p.price) + '</span></div>' +
        '<button type="button" class="b2-btn b2-btn--line" data-sumar="' + p.vid + '" data-pid="' + p.id + '">Sumar</button></div>';
    }).join('');
  }
  function busy(btn, on) { if (!btn) return; btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
  function showErr(form, msg) { var e = form && $('[data-err]', form); if (e) { e.textContent = msg; e.hidden = !msg; } }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-offer-form]'); if (!f) return;
    e.preventDefault();
    var r = $('input[name="id"]:checked', f) || $('input[name="id"]', f); if (!r) return;
    var btn = $('[data-order]', f); busy(btn, true); showErr(f, '');
    addVariant(r.value, f.getAttribute('data-pid')).then(openDr).catch(function (err) { showErr(f, err.message); }).then(function () { busy(btn, false); });
  });
  document.addEventListener('click', function (e) {
    var b;
    if ((b = e.target.closest('[data-add-comp]'))) {
      e.preventDefault(); busy(b, true);
      addVariant(b.getAttribute('data-vid'), b.getAttribute('data-pid')).then(openDr).catch(function (err) { alertInline(b, err.message); }).then(function () { busy(b, false); });
    } else if ((b = e.target.closest('[data-sumar]'))) {
      busy(b, true);
      addVariant(b.getAttribute('data-sumar'), b.getAttribute('data-pid')).catch(function () {}).then(function () { busy(b, false); });
    } else if ((b = e.target.closest('[data-rm]'))) {
      busy(b, true); removeKey(b.getAttribute('data-rm')).catch(function () { busy(b, false); });
    } else if ((b = e.target.closest('[data-open-pedido]'))) {
      openDr();
    } else if ((b = e.target.closest('[data-close-pedido]'))) {
      closeDr();
    } else if ((b = e.target.closest('[data-bar-go]'))) {
      var f = $('[data-offer-form]');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    } else if (dr && !dr.hidden && e.target === dr) {
      closeDr();
    }
  });
  function alertInline(el, msg) { el.textContent = msg; setTimeout(paint, 2500); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeLb(); closeDr(); } });

  /* ---------- Selector de oferta ---------- */
  function offers() {
    var f = $('[data-offer-form]'); if (!f) return;
    var radios = $$('input[name="id"][type="radio"]', f);
    function upd() {
      var sel = null;
      radios.forEach(function (r) { var c = r.closest('.b2-offer'); if (c) c.classList.toggle('is-on', r.checked); if (r.checked) sel = r; });
      var b = $('#b2-bar');
      if (sel && b) { $('[data-bar-price]', b).textContent = sel.getAttribute('data-price'); $('[data-bar-label]', b).textContent = sel.getAttribute('data-short'); }
    }
    radios.forEach(function (r) { r.addEventListener('change', upd); });
    upd();
  }

  /* ---------- Barra fija ---------- */
  var heroOut = false;
  function bar(on) { var b = $('#b2-bar'); if (b) b.classList.toggle('is-on', !!on); }
  function barCheck() { bar(heroOut && (!dr || dr.hidden)); }
  function barInit() {
    var hero = $('[data-hero]'), b = $('#b2-bar'); if (!hero || !b || !('IntersectionObserver' in window)) return;
    if (b.parentNode !== document.body) document.body.appendChild(b);
    new IntersectionObserver(function (ens) {
      var en = ens[0]; heroOut = !en.isIntersecting && en.boundingClientRect.top < 0; barCheck();
    }, { threshold: 0 }).observe(hero);
  }

  function init() { reveal(); gallery(); offers(); barInit(); load().catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) load().catch(function () {}); });
})();
